import { OriginalExperimentState } from 'modules/experiments/takeover/types';
import { ActionTypes } from '../actionTypes';

export const experimentEditDataLoaded = (payload: OriginalExperimentState) => ({
  type: ActionTypes.EXPERIMENT_DATA_LOADED,
  payload,
});

export const updateExperimentEditVariants = (
  variations: OriginalExperimentState['variations'],
) => ({
  type: ActionTypes.UPDATE_EXPERIMENT_VARIANTS,
  variations,
});

export const experimentEditDataErrored = () => ({
  type: ActionTypes.EXPERIMENT_DATA_ERRORED,
});

export const updateExperimentLocale = (payload = '') => ({
  type: ActionTypes.UPDATE_EXPERIMENT_LOCALE,
  payload,
});
